export const hashString = (str: string): string => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = Math.imul(hash, 31) + str.charCodeAt(i);
    hash = Math.floor(hash);
  }
  return hash.toString(16);
};
